import * as React from 'react';

export function FullBodyGrip4(props: React.SVGProps<SVGSVGElement>) {
	const maskA = React.useId().replace(/:/g, '');
	const maskB = React.useId().replace(/:/g, '');

	return (
		<svg width={29} height={56} viewBox="0 0 29 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M19.609 21.159a1.6 1.6 0 0 1-.616 1.08 1.66 1.66 0 0 1-1.215.334 1.74 1.74 0 0 1-.897-.377 7 7 0 0 1-.322-.357 5 5 0 0 1-.557-.815c-.316-.582-.31-.86-.566-1.377-.305-.66-.499-.602-1.339-1.656a15.7 15.7 0 0 1-1.457-2.164q-.148-.287-.279-.53l-.012-.017c-.11-.233-.216-.448-.293-.615a2.1 2.1 0 0 1-.097-.922 2.37 2.37 0 0 1 .91-1.582 2.43 2.43 0 0 1 1.785-.481 2.52 2.52 0 0 1 1.543.746l.014.02c.118.173.226.331.352.477q.005.016.018.025c.425.62.76 1.294.994 2.004.177.578.317 1.25.317 1.25.11.562.094.643.202 1.136.086.481.225.952.415 1.403.189.446.438.864.74 1.244a1.57 1.57 0 0 1 .36 1.174"
				fill="#8c8c8c"
			/>

			<path
				d="M23.172 27.586a1.17 1.17 0 0 1-.343.582 1.22 1.22 0 0 1-1.294.225 1.2 1.2 0 0 1-.529-.43 26 26 0 0 1-4.567-6.378 1.46 1.46 0 0 1-.266-1.17c.073-.292.23-.557.454-.763a1.61 1.61 0 0 1 1.701-.296c.283.118.524.314.696.564a9.6 9.6 0 0 1 1.592 2.493c.308.725.352 1.098.67 1.827a9 9 0 0 0 1.438 2.214 1.11 1.11 0 0 1 .448 1.132"
				fill="#8c8c8c"
			/>

			{/* MASK A */}
			<mask
				id={`maskA-${maskA}`}
				maskUnits="userSpaceOnUse"
				x={20}
				y={25}
				width={8}
				height={9}
				style={{ maskType: 'luminance' }}
			>
				<path d="m27.897 30.191-3.613 2.934-3.842-4.552 3.612-2.933z" fill="#fff" />
			</mask>

			<g mask={`url(#maskA-${maskA})`}>
				<path
					d="M24.098 31.71c.128-.12.042-.287-.076-.423l-.778-.81 1.259 1.31c.09.11.287.292.45.194s.11-.34-.038-.507c.196.282.436.5.615.371.117-.085.129-.249.014-.403l-1.41-1.6 1.203 1.365c.124.147.325.292.46.182.136-.11.08-.29-.02-.449 0 0-.912-1.296-1.12-1.524-.211-.254-.687-.824-.61-.992.17.075.359.136.564.288.236.148.672.11.821-.058.178-.276-.363-.426-.593-.575-.708-.462-1.006-.723-1.496-.888-.326-.115-.681-.299-1.336.107-.769.641-.817 1.27.31 2.804.255.338 1.225 1.374 1.44 1.532.134.098.258.154.341.075"
					fill="#8c8c8c"
				/>
			</g>

			<path
				d="M18.299 15.275c.01.433-.031 1.443-2.495 5.55-1.239 2.062-1.582 2.387-1.93 3.495-.293.915-.496 1.284-.727 2.338-.109.495-.223.977-.24 1.086-.17 1.086-.631 2.087-1.021 2.64a3.86 3.86 0 0 1-2.827.649 3.9 3.9 0 0 1-1.646-.637 3.8 3.8 0 0 1-1.184-1.289 9 9 0 0 1-.357-.908 6.43 6.43 0 0 1-.271-3.526 6.3 6.3 0 0 1 .632-1.601q.494-.762 1.087-1.453s.563-.755 1.013-1.52c.45-.767.631-1.426 1.026-3.334.563-2.729.594-3.2.722-3.658 0 0 .049-.199.12-.371.404-1.117 1.601-2.245 1.723-2.36.922-.857 1.116-.758 2.082-1.714a4.4 4.4 0 0 0 .91-1.095c.54-1.03.138-1.711.568-2.04.538-.412 1.757.164 2.452.74 1.088.886 1.695 2.454 1.235 3.274-.109.228-.283.42-.501.553-.372.205-.69.076-.975.33a.9.9 0 0 0-.247.436c-.154.553.225.881.518 1.724.25.876.362 1.783.333 2.69"
				fill="#8c8c8c"
			/>

			<path
				d="M22.559 6.712a9 9 0 0 1-.557 1.61 10 10 0 0 1-.63 1.11 4.4 4.4 0 0 1-.927 1.163 1.53 1.53 0 0 1-.707.397 1.77 1.77 0 0 1-1.28-.405 3 3 0 0 1-.636-.634c-.266-.33-.274-.443-.56-.853a8 8 0 0 0-.666-.814c-.608-.669-.686-.558-.975-.941a3.06 3.06 0 0 1-.586-1.668q.003-.557.154-1.093a3.78 3.78 0 0 1 1.858-2.169 3.9 3.9 0 0 1 2.877-.282c.96.277 1.773.91 2.265 1.765.491.854.623 1.863.367 2.81zM18.85 21.664a1.6 1.6 0 0 1-.616 1.08 1.66 1.66 0 0 1-1.215.334 1.74 1.74 0 0 1-.897-.378 7 7 0 0 1-.322-.356 5 5 0 0 1-.557-.815c-.316-.582-.31-.86-.566-1.377-.305-.66-.499-.603-1.339-1.656a15.7 15.7 0 0 1-1.457-2.164q-.149-.287-.279-.53l-.012-.017c-.11-.234-.216-.448-.293-.616a2.1 2.1 0 0 1-.097-.921c.038-.31.138-.61.294-.88a2.4 2.4 0 0 1 .616-.703 2.43 2.43 0 0 1 1.785-.48 2.52 2.52 0 0 1 1.543.745l.014.02c.118.174.226.332.352.478q.005.016.018.025c.425.62.76 1.294.994 2.004.177.578.317 1.25.317 1.25.11.562.094.643.202 1.136q.13.723.415 1.403c.189.446.438.864.74 1.244a1.57 1.57 0 0 1 .36 1.174"
				fill="#bfbfbf"
			/>

			<rect x={18.894} y={27.236} width={8.306} height={5.597} rx={1.083} fill="#8c8c8c" />

			<path
				d="M10.82 43.434c-.274.44-.717.75-1.234.865a2.08 2.08 0 0 1-1.522-.252 2.1 2.1 0 0 1-.798-.827 2 2 0 0 1-.235-1.103s.016-.018.006-.044l.057-.261.006-.064a8.5 8.5 0 0 0 .099-1.525 9.3 9.3 0 0 0-.509-2.648 47 47 0 0 1-1.285-5.092 18.4 18.4 0 0 1-.297-3.385.3.3 0 0 1-.007-.092q-.005-.249.02-.495a3.4 3.4 0 0 1 .483-1.518 3.73 3.73 0 0 1 2.366-1.668 4 4 0 0 1 2.925.484c.368.218.7.491.984.808a4.4 4.4 0 0 1 .99 2.601c.182 1.688-.019 2.816-.294 5.046-.38 3.096-.243 2.879-.5 4.371a34 34 0 0 1-1.064 4.4s-.02.023-.016.047a1.7 1.7 0 0 1-.175.352m4.683 11.64c-.1.423-.66.591-.947.67s-.442.068-1.649.041a6 6 0 0 1-1.052-.04c-.56-.107-.651-.272-1.21-.42a4.4 4.4 0 0 0-1.337-.14c-.815.021-.914.218-1.658.192a2.3 2.3 0 0 1-1.185-.283 1.37 1.37 0 0 1-.608-.646c-.147-.386.004-.766.307-1.516q.201-.49.456-.959.11-.257.14-.534 0-.258.058-.509a.95.95 0 0 1 .388-.438 1.35 1.35 0 0 1 1.185-.224 1.34 1.34 0 0 1 .889.798q.609.686 1.316 1.275.614.482 1.275.9a4 4 0 0 0 1.2.647q.428.086.866.121c1.027.143 1.196.21 1.334.359a.78.78 0 0 1 .232.706"
				fill="#8c8c8c"
			/>

			<path
				d="M11.234 42.847a37 37 0 0 1-.465 2.644c-.22 1.045-.405 1.58-.728 2.957a73 73 0 0 0-.684 3.064l-.003.043a1.3 1.3 0 0 1-.523.788 1.35 1.35 0 0 1-1.78-.202 1.28 1.28 0 0 1-.324-.885c.004-.085.03-.157.041-.233a15 15 0 0 0 .145-1.856 5.8 5.8 0 0 0-.122-1.693c-.062-.227-.157-.477-.26-.912a7 7 0 0 1-.092-.891c-.028-.664.205-2.04.863-3.734.113-.465.393-.875.79-1.153a2.05 2.05 0 0 1 2.642.25c.335.348.53.802.55 1.28 0 .177-.027.36-.05.533"
				fill="#8c8c8c"
			/>

			<path
				d="M22.413 28.091a1.17 1.17 0 0 1-.344.582 1.21 1.21 0 0 1-1.294.225 1.2 1.2 0 0 1-.528-.43 26 26 0 0 1-4.568-6.378 1.46 1.46 0 0 1-.265-1.17c.072-.292.23-.557.454-.763a1.61 1.61 0 0 1 1.701-.296c.282.118.524.314.695.564a9.6 9.6 0 0 1 1.592 2.493c.308.725.353 1.098.67 1.827a9 9 0 0 0 1.439 2.214 1.12 1.12 0 0 1 .448 1.132"
				fill="#bfbfbf"
			/>

			{/* MASK B */}
			<mask
				id={`maskB-${maskB}`}
				maskUnits="userSpaceOnUse"
				x={19}
				y={26}
				width={9}
				height={8}
				style={{ maskType: 'luminance' }}
			>
				<path d="m27.138 30.696-3.612 2.933-3.842-4.551 3.612-2.934z" fill="#fff" />
			</mask>

			<g mask={`url(#maskB-${maskB})`}>
				<path
					d="M23.34 32.214c.128-.12.042-.287-.076-.423l-.778-.809 1.258 1.309c.09.11.288.292.45.194.164-.097.112-.34-.037-.507.196.282.436.5.615.371.117-.085.129-.248.014-.403l-1.41-1.6 1.203 1.366c.124.147.325.292.46.181.136-.11.08-.289-.02-.448 0 0-.912-1.297-1.12-1.525-.211-.254-.687-.824-.61-.991.17.075.359.135.564.288.236.147.672.11.821-.06.178-.275-.363-.424-.593-.574-.709-.461-1.006-.723-1.496-.887-.326-.116-.681-.3-1.336.107-.769.64-.817 1.27.31 2.803.255.338 1.225 1.374 1.44 1.532.134.098.258.154.341.076"
					fill="#bfbfbf"
				/>
			</g>
		</svg>
	);
}
